export function html($els: JQuery<HTMLElement>, htmlStr: string): void {
    let len: number = $els.length;

    for (let i: number = 0; i < len; i++) {
        $els.get(i).innerHTML = htmlStr;
    }
}
